// checkout script extends category script
import "odprimanordicv2/base";

import Checkout from "od3dprimav2/app/components/checkout/Checkout.vue";
Vue.component("checkout", Checkout);
import InvoiceAddressSelectCheckout from "od3dprimav2/app/components/customer/addressSelectCheckoutCustom/InvoiceAddressSelect.vue";
Vue.component("invoice-address-select-checkout", InvoiceAddressSelectCheckout);
import ShippingAddressSelectCheckout from "od3dprimav2/app/components/customer/addressSelectCheckoutCustom/ShippingAddressSelect.vue";
Vue.component(
    "shipping-address-select-checkout",
    ShippingAddressSelectCheckout
);

import PaymentProviderSelect from "od3dprimav2/app/components/checkout/PaymentProviderSelect.vue";
Vue.component("payment-provider-select", PaymentProviderSelect);
import ShippingProfileSelect from "od3dprimav2/app/components/checkout/ShippingProfileSelect.vue";
Vue.component("shipping-profile-select", ShippingProfileSelect);
import Totals from "od3dprimav2/app/components/checkout/Totals.vue";
Vue.component("totals", Totals);
import AccountSettings from "od3dprimav2/app/components/myAccount/AccountSettings.vue";
Vue.component("account-settings", AccountSettings);

Vue.component("klarna-tracking", () =>
    import("~/app/components/checkout/KlarnaTracking.vue")
);
Vue.component("klarna-confirmation-tracking", () =>
    import("~/app/components/checkout/KlarnaConfirmationTracking.vue")
);

import "ceres/app/components/checkout/AcceptGtcCheck";
import "ceres/app/components/checkout/ContactWishInput";
import "ceres/app/components/checkout/CustomerSignInput";
import "ceres/app/components/checkout/PlaceOrder";
import "ceres/app/components/checkout/ShippingPrivacyHintCheck";
import "ceres/app/components/checkout/SubscribeNewsletterCheck";
import "od3dprimav2/app/components/checkout/ShippingProfileSelectBasket";
import BasketItemConsentCheck from "ceres/app/components/checkout/BasketItemConsentCheck.vue";
Vue.component("basket-item-consent-check", BasketItemConsentCheck);

import "ceres/app/components/customer/AddressSelect/AddressHeader";
import "od3dprimav2/app/components/customer/AddressSelect/InvoiceAddressSelect";
import "od3dprimav2/app/components/customer/AddressSelect/ShippingAddressSelect";

import "ceres/app/components/myAccount/BankDataSelect";
import "ceres/app/components/myAccount/ChangePaymentMethod";
import "ceres/app/components/myAccount/MyAccount";
import "ceres/app/components/myAccount/OrderDocuments";

// legacy non-shopbuilder components
import "od3dprimav2/app/components/myAccount/History";

// new shopbuilder-only component
Vue.component("edit-coupon-overlay", () =>
    import("ceres/app/components/myAccount/EditCouponOverlay.vue")
);
import "od3dprimav2/app/components/myAccount/OrderHistoryList";
import "ceres/app/components/myAccount/OrderReturnHistoryList";
import Vue from "vue";
